import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Size } from 'components/Button';
import { Wrapper, Text, StyledButton } from './CookieBanner.styled';

type CookieBannerProps = {
  onAccept: () => void;
};

const CookieBanner: React.FC<CookieBannerProps> = ({ onAccept }) => {
  return (
    <Wrapper>
      <div>
        <Text>
          <FormattedMessage
            id="app.home.cookies.info_1"
            defaultMessage="We use cookies on this site to enhance your user experience."
          />
        </Text>
        <Text>
          <FormattedMessage
            id="app.home.cookies.info_2"
            defaultMessage="For a complete overview of all please see our"
          />{' '}
          <Link to="/legal/privacy-policy">
            <FormattedMessage
              id="app.home.cookies.info_3_privacy"
              defaultMessage="Privacy Policy"
            />
          </Link>{' '}
          <FormattedMessage id="app.home.cookies.info_4_and" defaultMessage="and" />{' '}
          <Link to="/legal/terms-and-conditions">
            <FormattedMessage
              id="app.home.cookies.info_5_terms"
              defaultMessage="Terms and conditions"
            />
          </Link>
        </Text>
      </div>
      <StyledButton size={Size.SMALLEST} onClick={onAccept}>
        <FormattedMessage id="app.home.cookies.accept" defaultMessage="Accept" />
      </StyledButton>
    </Wrapper>
  );
};

export default CookieBanner;
